module.exports = __webpack_public_path__ + "media/bootstrap-icons/grip-vertical-d569b0af.svg";